import { useEffect } from 'react';
import { usePaymentTrackingProperties } from './usePaymentTrackingProperties';
export const useSetTrackerPaymentProperties = tracker => {
  const paymentTrackingProperties = usePaymentTrackingProperties();
  useEffect(() => {
    if (paymentTrackingProperties) {
      tracker.setProperties(paymentTrackingProperties);
    }
  }, [paymentTrackingProperties, tracker]);
};